import { APIS_RAOS_REPORT, TIMEOUTTIMEREPORT } from "@/constants/apis";
import axios from "axios";
import { ref } from "vue";
import { TOKEN } from '@/constants/labels';
import { showConsoleError } from '@/functions/errors'

export async function getLatencyHistoryReport(params: any) {

    /**
     * Estado de la Petición AXIOS
     */
    const statusAxios = ref()

    await axios
        .get(APIS_RAOS_REPORT.value.getLatencyHistoryReport, { params: params, timeout: TIMEOUTTIMEREPORT, headers: { "Authorization": `Bearer ${TOKEN}` } })
        .then((response) => {
            const finalData: any = response.data;
            const finalObj = ref<any[]>([]);
            const showGraphs = ref(finalData.length > 0);
            if (finalData.length > 0) {
                finalObj.value = finalData
            }
            statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
        })
        .catch(function (error) {
            statusAxios.value = { status: 400, data: [], showGraphs: false }
            showConsoleError(error)
        })
    return statusAxios.value
}

export async function getRajantDataHistoryReport(params: any) {

    /**
     * Estado de la Petición AXIOS
     */
    const statusAxios = ref()

    await axios
        .get(APIS_RAOS_REPORT.value.getRajantDataHistoryReport, { params: params, timeout: TIMEOUTTIMEREPORT, headers: { "Authorization": `Bearer ${TOKEN}` } })
        .then((response) => {
            const finalData: any = response.data;
            const finalObj = ref<any[]>([]);
            const showGraphs = ref(finalData.length > 0);
            if (finalData.length > 0) {
                finalObj.value = finalData
            }
            statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
        })
        .catch(function (error) {
            statusAxios.value = { status: 400, data: [], showGraphs: false }
            showConsoleError(error)
        })
    return statusAxios.value
}

export async function getSensoresHistoryReport(params: any) {

    /**
     * Estado de la Petición AXIOS
     */
    const statusAxios = ref()

    await axios
        .get(APIS_RAOS_REPORT.value.getSensoresHistoryReport, { params: params, timeout: TIMEOUTTIMEREPORT, headers: { "Authorization": `Bearer ${TOKEN}` } })
        .then((response) => {
            const finalData: any = response.data;
            const finalObj = ref<any[]>([]);
            const showGraphs = ref(finalData.length > 0);
            if (finalData.length > 0) {
                finalObj.value = finalData
            }
            statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
        })
        .catch(function (error) {
            statusAxios.value = { status: 400, data: [], showGraphs: false }
            showConsoleError(error)
        })
    return statusAxios.value
}

export async function getOperabilityHistoryReport(params: any) {

    /**
     * Estado de la Petición AXIOS
     */
    const statusAxios = ref()
    // timeout: TIMEOUTTIMEREPORT,
    await axios
        .get(APIS_RAOS_REPORT.value.getOperabilityHistoryReport, { params: params, headers: { "Authorization": `Bearer ${TOKEN}` } })
        .then((response) => {
            const finalData: any = response.data;
            const finalObj = ref<any[]>([]);
            const showGraphs = ref(finalData.length > 0);
            if (finalData.length > 0) {
                finalObj.value = finalData
            }
            statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
        })
        .catch(function (error) {
            statusAxios.value = { status: 400, data: [], showGraphs: false }
            showConsoleError(error)
        })
    return statusAxios.value
}

export async function getBandWidthDataHistoryReport(params: any) {

    /**
     * Estado de la Petición AXIOS
     */
    const statusAxios = ref()
    // timeout: TIMEOUTTIMEREPORT,
    await axios
        .get(APIS_RAOS_REPORT.value.getBandWidthDataHistoryReport, { params: params, headers: { "Authorization": `Bearer ${TOKEN}` } })
        .then((response) => {
            const finalData: any = response.data;
            const finalObj = ref<any[]>([]);
            const showGraphs = ref(finalData.length > 0);
            if (finalData.length > 0) {
                finalObj.value = finalData
            }
            statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
        })
        .catch(function (error) {
            statusAxios.value = { status: 400, data: [], showGraphs: false }
            showConsoleError(error)
        })
    return statusAxios.value
}
